import { InsurancePlan } from '@/catalog/types';
import { getDynamicCurrency } from '@/util-conversion/currency';

export function getInsurancePlanDeductibles(
  insurancePlans: InsurancePlan[] | null | undefined
) {
  const essentialPlanDeductible = getDynamicCurrency(
    insurancePlans?.find((plan) => plan.name === 'Essential Protection')
      ?.deductible_amount || 2000
  );

  const enhancedPlanDeductible = getDynamicCurrency(
    insurancePlans?.find((plan) => plan.name === 'Enhanced Protection')
      ?.deductible_amount || 500
  );

  return {
    essentialPlanDeductible,
    enhancedPlanDeductible,
  };
}
